import vuetifyLocalization from '@/helpers/json/vuetify.localization.json';

export const VuetifyLocale = {
  locale: 'en',
  fallback: 'en',
  messages: vuetifyLocalization,
};
